import { Row, Col } from 'react-bootstrap';
import Footer from '../../../ntisui/Molecules/Footer';
import { footerConstants } from '../../../../constants/Constants';

const RenderFooter = () => {
  return (
    <Row className="footer">
      <Col className="p-0">
        <Row>
          <Footer
            backgroundColor="#f2f2f2"
            displayLogo={false}
            links={footerConstants.footerLinks}
            borderTopWidth={5}
          />
        </Row>
      </Col>
    </Row>
  );
};

export default RenderFooter;
